@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-layout-basic/lib/index';

@import '~@adv-mt/mt-empty-case-default/lib/index';
@import '~@adv-mt/mt-hero-basic/lib/index';
@import '~@adv-mt/mt-list-compare/lib/index';
@import '~@adv-mt/mt-list-makes/lib/index';
@import '~@adv-mt/mt-list-marketed-versions/lib/index';
@import '~@adv-mt/mt-list-model-details/lib/index';
@import '~@adv-mt/mt-list-models/lib/index';
@import '~@adv-mt/mt-list-pagination/lib/index';
@import '~@adv-mt/mt-list-tag-chips/lib/index';
@import '~@adv-mt/mt-list-tagcloud/lib/index';
@import '~@adv-mt/mt-list-versions/lib/index';
@import '~@adv-mt/mt-modal-add-vehicle/lib/index';
@import '~@adv-mt/mt-navigation-breadcrumb/lib/index';
@import '~@adv-mt/mt-panel-add-vehicles/lib/index';
@import '~@adv-mt/mt-panel-equipment/lib/index';
@import '~@adv-mt/mt-panel-stores/lib/index';
@import '~@adv-mt/mt-search-header/lib/index';
@import '~@adv-mt/mt-search-sidebar/lib/index';
@import '~@adv-mt/mt-shared-section-wrapper/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@adv-mt/mt-technical-detail-make-title/lib/index';
@import '~@adv-mt/mt-technical-details-panel-links/lib/index';
@import '~@adv-mt/mt-technical-details-panel-slider/lib/index';

@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-molecule-checkbox-field/lib/index';

.mt-TechnicalDetailsHome {
  &-title {
    font-size: $fz-xxxl;
    margin: 0;
  }

  &-searchLinkWrapper {
    text-align: right;
    padding-top: $p-xxl;
  }

  &-searchLink {
    color: $c-primary;
    text-decoration: none;
    font-size: $fz-m;

    &:hover {
      color: $c-primary-dark;
    }
  }
}
